<div class="modal-header no-icon">
    <h3 class="modal-title">Organisation LOTAM Announcements</h3>
    <button type="button" (click)="close()" aria-label="Close" class="close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body no-footer">
    <div class="modal-body-content container-scroll">
        <div class="horizontal-container">
            <div class="fcol-8">
                <div class="search-container">
                    <input
                        type="text"
                        class="form-control search-input"
                        placeholder="Search anything in LOTAMs..."
                        (input)="onSearch($event.target.value)"
                    />
                    <i class="fa fa-search search-icon"></i>
                    <i
                        class="fa fa-times clear-icon"
                        (click)="clearSearch()"
                    ></i>
                </div>
            </div>
            <div class="fill">
                <button
                    *ngIf="canAddNotice"
                    class="btn btn-default-action btn-sm pull-right"
                    type="button"
                    [disabled]="working"
                    (click)="createLotam()"
                >
                    Create LOTAM
                </button>
            </div>
        </div>
        <loading-indicator [isLoading]="working"></loading-indicator>
        <div class="static-table-container">
            <static-table
                [availableColumns]="availableColumns"
                [selectedColumns]="selectedColumns"
                [tableData]="lotams"
                [tableConfig]="tableConfig"
                [borderless]="false"
                [underlinedRows]="true"
                scanability="comfortable"
                (pageChanged)="onTablePageChanged($event)"
                (selectedColumnsChanged)="
                    updateSelectedColumns($event.selectedColumns)
                "
                (sortOrderChanged)="updateColumnSorting($event)"
                (itemLimitUpdated)="updateItemLimit($event)"
                (search)="onTableSearch($event)"
            >
                <ng-template
                    columnTemplate="subject"
                    let-row="row"
                    let-column="column"
                >
                    <a
                        [innerHTML]="
                            row.subject | formatEmptyTitle | unsafeHtml
                        "
                        (click)="viewElement(row)"
                    >
                    </a>
                </ng-template>
                <ng-template
                    columnTemplate="noticeType.name"
                    let-row="row"
                    let-column="column"
                >
                    <notice-type-list-item
                        [noticeType]="row?.noticeType"
                    ></notice-type-list-item>
                </ng-template>
                <ng-template
                    columnTemplate="audience"
                    let-row="row"
                    let-column="column"
                >
                    {{ formatAudience[row.audience] }}
                </ng-template>
                <ng-template
                    columnTemplate="importance"
                    let-row="row"
                    let-column="column"
                >
                    <div class="importance-cell">
                        <span
                            class="status-cell"
                            [ngClass]="{
                                low:
                                    row.importance === NoticeDto.Importance.LOW,
                                medium:
                                    row.importance ===
                                    NoticeDto.Importance.MEDIUM,
                                high:
                                    row.importance === NoticeDto.Importance.HIGH
                            }"
                        >
                            {{
                                row.importance != null
                                    ? formatLotamPriority[row.importance]
                                    : ''
                            }}
                        </span>
                    </div>
                </ng-template>
                <ng-template
                    columnTemplate="acknowledged"
                    let-row="row"
                    let-column="column"
                >
                    <div
                        *ngIf="
                            row.audience !==
                                NoticeDto.Audience.FLIGHT_OPERATIONS &&
                            row.requiresAcknowledgement
                        "
                        class="checkbox acknowledge-checkbox-container"
                        [ngClass]="{
                            complete: row.isAcknowledged,
                            incomplete: !row.isAcknowledged
                        }"
                        style="width: 150px"
                    >
                        <label
                            [ngClass]="{
                                acknowledged: row.isAcknowledged
                            }"
                        >
                            <input
                                type="checkbox"
                                [disabled]="working"
                                [ngModel]="row.isAcknowledged"
                                (click)="onAcknowledge($event, row)"
                            />
                            <span class="cr"
                                ><i class="cr-icon glyphicon glyphicon-ok"></i
                            ></span>
                            {{
                                row.isAcknowledged
                                    ? 'Acknowledged'
                                    : 'Acknowledge'
                            }}
                        </label>
                    </div>
                </ng-template>
                <ng-template
                    columnTemplate="activityTime"
                    let-row="row"
                    let-column="column"
                >
                    {{
                        row.startTime
                            | formatDateRange: row.endTime:organisation.timeZone
                    }}
                </ng-template>
            </static-table>
        </div>
    </div>
</div>
